import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deleteMessageForMe,
  deleteMessageForEveryone,
} from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

interface DeleteMessagePayload {
  chatId: number;
  messageId: number;
  scope: "me" | "everyone";
}

export const useDeleteMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ chatId, messageId, scope }: DeleteMessagePayload) =>
      scope === "everyone"
        ? deleteMessageForEveryone(chatId, messageId)
        : deleteMessageForMe(chatId, messageId),
    onSuccess: (_data, { chatId }) => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessages, chatId],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessagesPaginated, chatId],
      });
      queryClient.invalidateQueries({ queryKey: [ChatsQueryKeys.Chats] });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
